import _ from "@lodash";
import { AppBar, DialogContent, IconButton, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import React from "react";
import { MdClose } from "react-icons/md";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import MobileDetect from "mobile-detect";
import MeusConvitesApp from "app/Core/Funcionalidade/MeusConvites/MeusConvitesApp";

const md = new MobileDetect(window.navigator.userAgent);

const styles = () => ({
    button: {
        borderColor: "#666 !important",
        color: "#666 !important",

    }
});


class CheckConvites extends XAPPComponent {

    state = { openDialog: false }

    componentDidUpdate(prevProps) {
        const { user = null } = this.props;
        const { openDialog } = this.state;

        if (!openDialog && !_.isNull(user) && !_.isUndefined(user.existsconvite) && Number(user.existsconvite) > 0) {
            setTimeout(() => {
                this.changeDialog(true);
                delete user.existsconvite;
            }, 3000);
        }
    }

    changeDialog = (_AValue = false) => {
        this.setState(_.set({ ...this.state }, "openDialog", _AValue));
    }

    render() {
        const { openDialog } = this.state;
        const { empresa, user } = this.props;

        return (
            <React.Fragment>
                <XAPPDialog
                    id="Convites"
                    open={openDialog}
                    onClose={() => this.changeDialog()}
                    fullWidth
                    fullScreen={md.mobile() !== null}
                    maxWidth={"md"}
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {"Convites"}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => this.changeDialog()}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "p-24" }}>
                        <MeusConvitesApp
                            idpessoa={user.idpessoa}
                        />
                    </DialogContent>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}

function mapStateToProps({ auth, fuse }) {
    return {
        user: auth.user.data,
        empresa: fuse.navigation.empresa,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(CheckConvites)));